module.exports = __webpack_public_path__ + "static/openathens--grey-944cf2b7fb98513fea723303a2b3cca8.png";